// State type
export type View = "reset" | "set" | "success";

export interface PasswordState {
	view: View;
	backgroundImage: string;
	newPassword: string;
	confirmNewPassword: string;
	showNewPassword: boolean;
	showConfirmPassword: boolean;
	setPwLoading: boolean;
	setPwError: string;
	linkError: string;
	userType?: "mentor" | "mentee";
}

// Action types
export type PasswordAction =
	| { type: "SET_BACKGROUND"; payload: string }
	| { type: "SET_NEW_PASSWORD"; payload: string }
	| { type: "SET_CONFIRM_PASSWORD"; payload: string }
	| { type: "TOGGLE_SHOW_NEW_PASSWORD" }
	| { type: "TOGGLE_SHOW_CONFIRM_PASSWORD" }
	| { type: "SET_PASSWORD_START" }
	| { type: "SET_PASSWORD_SUCCESS"; payload?: "mentor" | "mentee" }
	| { type: "SET_PASSWORD_ERROR"; payload: string }
	| { type: "SET_LINK_ERROR"; payload: string };

// Initial state factory
export function createInitialState(view: View = "reset"): PasswordState {
	return {
		view,
		backgroundImage: "",
		newPassword: "",
		confirmNewPassword: "",
		showNewPassword: false,
		showConfirmPassword: false,
		setPwLoading: false,
		setPwError: "",
		linkError: "",
	};
}

// Reducer function
export function passwordReducer(
	state: PasswordState,
	action: PasswordAction,
): PasswordState {
	switch (action.type) {
		case "SET_BACKGROUND":
			return { ...state, backgroundImage: action.payload };

		case "SET_NEW_PASSWORD":
			return { ...state, newPassword: action.payload };

		case "SET_CONFIRM_PASSWORD":
			return { ...state, confirmNewPassword: action.payload };

		case "TOGGLE_SHOW_NEW_PASSWORD":
			return { ...state, showNewPassword: !state.showNewPassword };

		case "TOGGLE_SHOW_CONFIRM_PASSWORD":
			return { ...state, showConfirmPassword: !state.showConfirmPassword };

		case "SET_PASSWORD_START":
			return { ...state, setPwLoading: true, setPwError: "" };

		case "SET_PASSWORD_SUCCESS":
			return {
				...state,
				setPwLoading: false,
				newPassword: "",
				confirmNewPassword: "",
				view: "success",
				userType: action.payload,
			};

		case "SET_PASSWORD_ERROR":
			return { ...state, setPwLoading: false, setPwError: action.payload };

		case "SET_LINK_ERROR":
			return { ...state, linkError: action.payload };

		default:
			return state;
	}
}
